<template>
  <div class="">
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="800px"
      :close-on-click-modal="false"
      @close="close"
    >
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item label="奖惩类型" :required="true" prop="type">
          <el-select v-model="form.type" :placeholder="$t('common.pleaseSelect')">
            <el-option label="惩罚" :value="1"></el-option>
            <el-option label="奖励" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="骑手" prop="id" :required="true" >
          <el-select
            v-model="form.id"
            :placeholder="$t('common.pleaseSelect')"
            @change="selectRider"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.userName"
              :value="parseInt(item.id)"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="奖励类别" :required="true" prop="item">
          <el-select v-model="form.item" :placeholder="$t('common.pleaseSelect')">
            <el-option label="变更余额" :value="1"></el-option>
            <el-option label="通知警告" :value="2"></el-option>
            <el-option label="禁止接单" :value="3"></el-option>
            <el-option label="冻结账号" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="时间"
          v-if="form.item == '3' || form.item == '4'"
          prop="timeData"
        >
          <el-date-picker
            v-model="form.timeData"
            type="daterange"
            :range-separator="$t('common.to')"
            :start-placeholder="$t('common.startDate')"
            :end-placeholder="$t('common.endDate')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="奖惩金额" :required="true" prop="money">
          <el-input
            v-model.trim="form.money"
            autocomplete="off"
            placeholder="请输入奖惩金额"
          ></el-input>
        </el-form-item>
        <el-form-item label="奖惩原因" :required="true">
          <el-input
            v-model.trim="form.note"
            autocomplete="off"
            placeholder="请输入每日可取消数"
            type="textarea"
            :row="6"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否通知骑手" :required="true" prop="noticeType">
          <el-radio v-model="form.noticeType" :label="1">不通知</el-radio>
          <el-radio v-model="form.noticeType" :label="2"
            >仅通知奖惩骑手</el-radio
          >
          <el-radio v-model="form.noticeType" :label="3">通知所有骑手</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
        <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { changeDate } from "@/utils/index";
import { sanctionSave, selectRider, getSanction } from "@/api/rider";
export default {
  name: "labelSave",

  data() {
    return {
      form: {
        type: "",
        riderId: "",
        money: "",
        note: "",
        item: "",
        noticeType: "",
        timeData: "",
        value: "",
      },
      options: [],
      title: "",
      dialogFormVisible: false,
    };
  },
  components: {},
  created() {
    this.getRiderList();
  },
  methods: {
    async getRiderList() {
      const { data } = await selectRider();
      this.options = data;
    },
    selectRider(val) {
      this.form.riderId = val;
    },
    showEdit(id) {
      if (!id) {
        this.title = "添加";
      } else {
        this.title = "编辑";
        this.getSanctionInfo(id);
      }
      this.dialogFormVisible = true;
    },
    close() {
      this.$refs["form"].resetFields();
      this.form = this.$options.data().form;
      this.dialogFormVisible = false;
    },
    save() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.timeData) {
            this.form.startAt = changeDate(this.form.timeData[0]);
            this.form.endAt = changeDate(this.form.timeData[1]);
          }
          const { msg } = await sanctionSave(this.form);
          this.$baseMessage(msg, "success");
          this.$emit("fetchData");
          this.close();
        } else {
          return false;
        }
      });
    },
    async getSanctionInfo(id) {
      const { data } = await getSanction({ id });
      Object.assign(this.form, data);
    },
  },
};
</script>
